<div class="box">
  <span class="icone icon_atencao"></span>
  <h1>Na análise final, ainda é possível ajustar o preço 
     <br> caso necessário para fechar contrato.
  </h1>
</div>